module.exports = {
      id: "arrow-down-usage",
      viewBox: "0 0 9 12",
      url: __webpack_public_path__ + "img/symbols.e4df9320ab0fa712c143543fa64d490c.svg#arrow-down",
      toString: function () {
        return this.url;
      }
    }